
export default {

  init() {

    },
  finalize() {
    // JavaScript to be fired on the single downloads page
    const type = downloadinfo['type'];
    const file = downloadinfo['file'];

    if(type == 'video') {
      $('#play').on('click', function(e) {
        e.preventDefault();
        $("#player")[0].src += "?autoplay=1";
        $('#player').show();
        $('#video-cover').hide();
        $('#play').hide();
      })

    }

    if(type != 'application' && type != 'video') {
      // Redirect to download after 5 seconds
      setTimeout(function () {
        const url = '/app/uploads/downloads/'+file;
        window.location = url;
      }, 2000);

    }


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-downloads.js